var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Headers, Http, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from "../../../environments/environment";
import 'rxjs/Rx';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { SSO } from './../../sso/sso.constants';
import { CookieService } from 'ngx-cookie-service';
import { RealmType } from '../enums/realm-type.enum';
import { EncryptionService } from "../../sso/encryption.service";
var HttpService = /** @class */ (function (_super) {
    __extends(HttpService, _super);
    function HttpService(backend, defaultOptions) {
        var _this = _super.call(this, backend, defaultOptions) || this;
        _this.cookieService = new CookieService(document);
        return _this;
    }
    /**
     * Performs any type of http request.
     * @param url
     * @param options
     * @returns {Observable<Response>}
     */
    HttpService.prototype.request = function (url, options) {
        return _super.prototype.request.call(this, url, options);
    };
    /**
     * Performs a request with `get` http method.
     * @param url
     * @param options
     * @returns {Observable<>}
     */
    HttpService.prototype.get = function (url, options) {
        var _this = this;
        this.requestInterceptor(options);
        return _super.prototype.get.call(this, this.getFullUrl(url), this.requestOptions(url, options))
            .do(function (res) {
            _this.onSubscribeSuccess(res);
        }, function (error) {
            _this.onSubscribeError(error);
        })
            .catch(this.onCatch)
            .finally(function () {
            _this.onFinally();
        });
    };
    HttpService.prototype.getLocal = function (url, options) {
        return _super.prototype.get.call(this, url, options);
    };
    /**
     * Performs a request with `post` http method.
     * @param url
     * @param body
     * @param options
     * @returns {Observable<>}
     */
    HttpService.prototype.post = function (url, body, options) {
        var _this = this;
        this.requestInterceptor(options);
        return _super.prototype.post.call(this, this.getFullUrl(url), body, this.requestOptions(url, options))
            .catch(this.onCatch)
            .do(function (res) {
            _this.onSubscribeSuccess(res);
        }, function (error) {
            _this.onSubscribeError(error);
        })
            .finally(function () {
            _this.onFinally();
        });
    };
    /**
     * Performs a request with `put` http method.
     * @param url
     * @param body
     * @param options
     * @returns {Observable<>}
     */
    HttpService.prototype.put = function (url, body, options) {
        var _this = this;
        this.requestInterceptor(options);
        return _super.prototype.put.call(this, this.getFullUrl(url), body, this.requestOptions(url, options))
            .catch(this.onCatch)
            .do(function (res) {
            _this.onSubscribeSuccess(res);
        }, function (error) {
            _this.onSubscribeError(error);
        })
            .finally(function () {
            _this.onFinally();
        });
    };
    /**
     * Performs a request with `delete` http method.
     * @param url
     * @param options
     * @returns {Observable<>}
     */
    HttpService.prototype.delete = function (url, options) {
        var _this = this;
        this.requestInterceptor(options);
        return _super.prototype.delete.call(this, this.getFullUrl(url), this.requestOptions(url, options))
            .catch(this.onCatch)
            .do(function (res) {
            _this.onSubscribeSuccess(res);
        }, function (error) {
            _this.onSubscribeError(error);
        })
            .finally(function () {
            _this.onFinally();
        });
    };
    /**
     * Performs a request with `delete` http method.
     * @param url
     * @param options
     * @returns {Observable<>}
     */
    HttpService.prototype.patch = function (url, body, options) {
        var _this = this;
        this.requestInterceptor(options);
        return _super.prototype.patch.call(this, this.getFullUrl(url), body, this.requestOptions(url, options))
            .catch(this.onCatch)
            .do(function (res) {
            _this.onSubscribeSuccess(res);
        }, function (error) {
            _this.onSubscribeError(error);
        })
            .finally(function () {
            _this.onFinally();
        });
    };
    /**
     * Request options.
     * @param options
     * @returns {RequestOptionsArgs}
     */
    HttpService.prototype.requestOptions = function (url, options) {
        if (options == null) {
            options = new RequestOptions();
        }
        if (!(options && options.headers && options.headers.has('termsAndCondition'))) {
            var loginId = SSO.isRemoveObsoleteCookie() ? this.cookieService.get(SSO.INTERNAL_MEMBER_SESSIONID) : this.cookieService.get(SSO.INTERNAL_ACCESS_TOKEN);
            if (!loginId) {
                var userInfo = localStorage.getItem("appadmin.UserInfo");
                if (userInfo) {
                    localStorage.removeItem("appadmin.UserInfo");
                    window.location.reload();
                }
            }
            else {
                if (SSO.isRemoveObsoleteCookie()) {
                    var localMemberSessionId = localStorage.getItem(SSO.LOCAL_MEMBER_SESSION_ID);
                    if (localMemberSessionId !== loginId) {
                        window.location.reload();
                    }
                }
            }
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }
        if (!options.headers.has('Content-Type')) {
            options.headers.append('Content-Type', 'application/json');
        }
        else {
            options.headers.delete('Content-Type');
        }
        if (url.startsWith(environment.apiUrl) && !url.startsWith(environment.apiUrl + "/payment/")) {
            var uuid = SSO.getnonce();
            options.headers.append('UUID', uuid);
            var accessToken = SSO.isRemoveObsoleteCookie() ? localStorage.getItem(SSO.INTERNAL_ACCESS_TOKEN) : this.cookieService.get(SSO.INTERNAL_ACCESS_TOKEN);
            if (options && options.headers && options.headers.has('termsAndCondition')) {
                accessToken = " ";
                if (options.headers.has('guestToken')) {
                    accessToken = JSON.parse(localStorage.getItem('appadmin.guestToken'));
                    if (environment.isEnabledOfflineTitanFlow) {
                        options.headers.set('isOfflineFlow', 'true');
                    }
                }
            }
            if (accessToken) {
                var header = '';
                if (options && options.headers && options.headers.has('guestToken')) {
                    header = 'Bearer ' + accessToken + "&&" + RealmType.TITAN_GUEST;
                }
                else {
                    header = 'Bearer ' + accessToken + "&&" + RealmType.TITAN_INTERNAL;
                }
                if (environment.enableAuthorization) {
                    options.headers.append('Authorization', this.getAuthorizationHeader(header, uuid));
                }
                if (environment.enableAuthentication) {
                    options.headers.append('Authentication', header);
                }
            }
        }
        if (options && options.headers && (options.headers.has('termsAndCondition') || options.headers.has('guestToken'))) {
            options.headers.delete('termsAndCondition');
            options.headers.delete('guestToken');
        }
        return options;
    };
    HttpService.prototype.getAuthorizationHeader = function (token, uuid) {
        var data = uuid + '||' + token;
        return EncryptionService.encryptText(data);
    };
    /**
     * Build API url.
     * @param url
     * @returns {string}
     */
    HttpService.prototype.getFullUrl = function (url) {
        // return full URL to API here
        //  Remove duplicate slash from request url        
        if (url) {
            url = url.replace(/([^:]\/)\/+/g, "$1");
        }
        return url;
    };
    /**
     * Request interceptor.
     */
    HttpService.prototype.requestInterceptor = function (options) {
    };
    /**
     * Response interceptor.
     */
    HttpService.prototype.responseInterceptor = function () {
    };
    /**
     * Error handler.
     * @param error
     * @param caught
     * @returns {ErrorObservable}
     */
    HttpService.prototype.onCatch = function (error, caught) {
        if (error && error.url && error.url.startsWith(environment.ssoApiURL.split("/auth/realm")[0]) || error.url.startsWith(environment.apiUrl)) {
            if (error.status == 401) {
                window.location.href = decodeURIComponent(encodeURIComponent(window.location.href));
            }
        }
        return Observable.throw(error.json());
    };
    /**
     * onSubscribeSuccess
     * @param res
     */
    HttpService.prototype.onSubscribeSuccess = function (res) {
        if (res !== null && res !== undefined) {
        }
    };
    /**
     * onSubscribeError
     * @param error
     */
    HttpService.prototype.onSubscribeError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
    };
    /**
     * onFinally
     */
    HttpService.prototype.onFinally = function () {
        this.responseInterceptor();
    };
    return HttpService;
}(Http));
export { HttpService };



// WEBPACK FOOTER //
// ./src/app/shared/Utils/http.service.ts.pre-build-optimizer.js